// Photo de terrain (signalement, rapport) chargée derrière le jeton de session puis affichée en
// vignette ; état de chargement et d'erreur écrits. L'adresse d'objet est révoquée au démontage.
import { Squelette } from '@cc/ui';
import { useEffect, useState } from 'react';
import { chargerPhoto } from './api';
import type { Photo as PhotoApi } from './types';
import styles from './interventions.module.css';

export function Photo({ photo, charger = chargerPhoto }: { photo: PhotoApi; charger?: (id: string, signal?: AbortSignal) => Promise<string> }) {
  const [url, setUrl] = useState<string | null>(null);
  const [erreur, setErreur] = useState(false);
  useEffect(() => {
    const controleur = new AbortController();
    let adresse: string | null = null;
    charger(photo.id, controleur.signal)
      .then((u) => {
        adresse = u;
        setUrl(u);
      })
      // Une requête abandonnée (démontage, double montage en développement) n'est pas une erreur.
      .catch(() => {
        if (!controleur.signal.aborted) setErreur(true);
      });
    return () => {
      controleur.abort();
      if (adresse) URL.revokeObjectURL(adresse);
    };
  }, [photo.id, charger]);
  if (erreur) return <p className={styles.photoEtat}>Photo indisponible ({photo.titre}).</p>;
  if (!url) return <Squelette hauteurBloc={96} libelle={`Chargement de ${photo.titre}`} />;
  return (
    <figure className={styles.photo}>
      <img src={url} alt={photo.titre} />
      <figcaption>{photo.titre}</figcaption>
    </figure>
  );
}

export function Photos({ photos, vide = 'Aucune photo.', charger }: { photos: PhotoApi[]; vide?: string; charger?: (id: string, signal?: AbortSignal) => Promise<string> }) {
  if (photos.length === 0) return <p className={styles.photoEtat}>{vide}</p>;
  return (
    <ul className={styles.photos} aria-label="Photos">
      {photos.map((p) => (
        <li key={p.id}>
          <Photo photo={p} charger={charger} />
        </li>
      ))}
    </ul>
  );
}
